import React from 'react';

function Saving() {
    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-white/85 text-black z-[1000]">
            <div className="bg-white px-[4em] py-[2em] rounded-xl border border-[#ddd] shadow-[0_24px_80px_rgba(0,0,0,0.1)]">
                <p className="text-center font-bold m-0">Ukládám...</p>
                <div className="rounded-full w-[5em] h-[5em] my-[1em] mx-auto relative indent-[-9999em] border-[0.7em] border-solid border-[#e7e7e7] border-t-[#4eb32d] [animation:load8_1s_infinite_linear]"></div>
            </div>
        </div>
    );
}

export default Saving;
